<template>
    <div class="cis-trans-isomerie">
        <ul>
            <li>an Doppelbindung</li>
            <li>mit unterschiedlichen Resten / Liganten</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'cis-trans-isomerie',
};
</script>
